!(function () {
    "use strict";
    var t = "data-section-id";
    function e(e, n) {
        (this.container = (function (e) {
            if (!(e instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
            if (null === e.getAttribute(t)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the data-section-id attribute.");
            return e;
        })(e)),
            (this.id = e.getAttribute(t)),
            (this.extensions = []),
            Object.assign(
                this,
                (function (t) {
                    if ((void 0 !== t && "object" != typeof t) || null === t) throw new TypeError("Theme Sections: The properties object provided is not a valid");
                    return t;
                })(n)
            ),
            this.onLoad();
    }
    (e.prototype = {
        onLoad: Function.prototype,
        onUnload: Function.prototype,
        onSelect: Function.prototype,
        onDeselect: Function.prototype,
        onBlockSelect: Function.prototype,
        onBlockDeselect: Function.prototype,
        extend: function (t) {
            this.extensions.push(t);
            var e = Object.assign({}, t);
            delete e.init, Object.assign(this, e), "function" == typeof t.init && t.init.apply(this);
        },
    }),
        "function" != typeof Object.assign &&
            Object.defineProperty(Object, "assign", {
                value: function (t) {
                    if (null == t) throw new TypeError("Cannot convert undefined or null to object");
                    for (var e = Object(t), n = 1; n < arguments.length; n++) {
                        var o = arguments[n];
                        if (null != o) for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (e[i] = o[i]);
                    }
                    return e;
                },
                writable: !0,
                configurable: !0,
            });
    var n = "data-section-type";
    (window.Shopify = window.Shopify || {}), (window.Shopify.theme = window.Shopify.theme || {}), (window.Shopify.theme.sections = window.Shopify.theme.sections || {});
    var o = (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
        i = (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    function r(t, e) {
        (t = s(t)),
            void 0 === e && (e = document.querySelectorAll("[data-section-type]")),
            (e = d(e)),
            t.forEach(function (t) {
                var r = o[t];
                void 0 !== r &&
                    (e = e.filter(function (e) {
                        return !(c(e).length > 0 || null === e.getAttribute(n) || (e.getAttribute(n) === t && (i.push(new r(e)), 1)));
                    }));
            });
    }
    function c(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var n = t[0];
        return (
            t instanceof Element || n instanceof Element
                ? d(t).forEach(function (t) {
                      e = e.concat(
                          i.filter(function (e) {
                              return e.container === t;
                          })
                      );
                  })
                : ("string" != typeof t && "string" != typeof n) ||
                  s(t).forEach(function (t) {
                      e = e.concat(
                          i.filter(function (e) {
                              return e.type === t;
                          })
                      );
                  }),
            e
        );
    }
    function a(t) {
        for (var e, n = 0; n < i.length; n++)
            if (i[n].id === t) {
                e = i[n];
                break;
            }
        return e;
    }
    function s(t) {
        return (
            "*" === t
                ? (t = Object.keys(o))
                : "string" == typeof t
                ? (t = [t])
                : t.constructor === e
                ? (t = [t.prototype.type])
                : Array.isArray(t) &&
                  t[0].constructor === e &&
                  (t = t.map(function (t) {
                      return t.prototype.type;
                  })),
            t.map(function (t) {
                return t.toLowerCase();
            })
        );
    }
    function d(t) {
        return (
            NodeList.prototype.isPrototypeOf(t) && t.length > 0
                ? (t = Array.prototype.slice.call(t))
                : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
                ? (t = [])
                : !Array.isArray(t) && t instanceof Element && (t = [t]),
            t
        );
    }
    function u(t) {
        return (async function (t, e) {
            return (await fetch(t, { method: "POST", headers: { "X-Requested-With": "XMLHttpRequest", "Content-Type": "application/json;" }, body: JSON.stringify(e) })).json();
        })("/cart/change.js", t);
    }
    async function l(t) {
        const e = await fetch("/?" + new URLSearchParams({ sections: t }));
        return await e.json();
    }
    function p(t, e = []) {
        const [n, o] = Object.entries(t)[0],
            i = document.querySelector(`#shopify-section-${n}`);
        e.length > 0
            ? e.forEach((t) => {
                  i.querySelector(t).innerHTML = f(o, t);
              })
            : (i.innerHTML = f(o));
    }
    function f(t, e = ".shopify-section") {
        return new DOMParser().parseFromString(t, "text/html").querySelector(e).innerHTML;
    }
    window.Shopify.designMode &&
        (document.addEventListener("shopify:section:load", function (t) {
            var e = t.detail.sectionId,
                o = t.target.querySelector('[data-section-id="' + e + '"]');
            null !== o && r(o.getAttribute(n), o);
        }),
        document.addEventListener("shopify:section:unload", function (t) {
            var e = t.detail.sectionId,
                n = t.target.querySelector('[data-section-id="' + e + '"]');
            "object" == typeof c(n)[0] &&
                c(n).forEach(function (t) {
                    var e = i
                        .map(function (t) {
                            return t.id;
                        })
                        .indexOf(t.id);
                    i.splice(e, 1), t.onUnload();
                });
        }),
        document.addEventListener("shopify:section:select", function (t) {
            var e = a(t.detail.sectionId);
            "object" == typeof e && e.onSelect(t);
        }),
        document.addEventListener("shopify:section:deselect", function (t) {
            var e = a(t.detail.sectionId);
            "object" == typeof e && e.onDeselect(t);
        }),
        document.addEventListener("shopify:block:select", function (t) {
            var e = a(t.detail.sectionId);
            "object" == typeof e && e.onBlockSelect(t);
        }),
        document.addEventListener("shopify:block:deselect", function (t) {
            var e = a(t.detail.sectionId);
            "object" == typeof e && e.onBlockDeselect(t);
        })),
        (function (t, n) {
            if (void 0 !== o.cart) throw new Error('Theme Sections: A section of type "cart" has already been registered. You cannot register the same section type twice');
            function i(t) {
                e.call(this, t, n);
            }
            (i.constructor = e), (i.prototype = Object.create(e.prototype)), (i.prototype.type = t), (o.cart = i);
        })("cart", {
            removeButton: "[data-cart-remove-item]",
            update_input: "[data-ck]",
            increaseButton: "[data-cart-increase-item]",
            decreaseButton: "[data-cart-decrease-item]",
            quantity: "[data-cart-quantity]",
            onLoad: function () {
                this.init();
            },
            init() {
                this._removeHandler(), this._increaseHandler(), this._decreaseHandler(),  this._update_ck(), (this.loading = !1);
            },
            updateCart() {
                (async function () {
                    return (await fetch("/cart.js", { method: "GET", headers: { "X-Requested-With": "XMLHttpRequest", "Content-Type": "application/json;" } })).json();
                })()
                    .then((t) => {
                        console.log(t),
                            (document.querySelector("[data-cart-count]").innerHTML = t.item_count),
                            (document.querySelector("[data-cartCount]").innerHTML = t.item_count),
                            (document.querySelector("[data-cartItems-count]").innerHTML = t.item_count);
                    })
                    .catch((t) => console.error(t)),
                    l("template--15287686398022__cart-items")
                        .then((t) => p(t, ["#free-shipping-cart", "cart-items > div", "#cart-footer"]))
                        .then(() => {
                            this.init();
                        })
                        .catch((t) => {
                            console.error(t);
                        }),
                    l("cart-drawer")
                        .then((t) => p(t, ["#free-shipping", "cart-items > div", "#cart-footer"]))
                        .then(() => {
                            this.init();
                        })
                        .catch((t) => {
                            console.error(t);
                        });
            },
            _getQuantity: (t) => parseInt(t.parentElement.querySelector("[data-cart-quantity]").value),
            _eventHandler(t, e) {
                document.querySelectorAll(t).forEach((t) => {
                    t.addEventListener("click", (n) => {
                        n.preventDefault(),
                            (this.loading = !0),
                            e(t)
                                .then((t) => this.updateCart())
                                .catch((t) => console.error(t));
                    });
                });
            },
          _eventHandler_ck(t, e) {
                document.querySelectorAll(t).forEach((t) => {
                    t.addEventListener("change", (n) => {
                        n.preventDefault(),
                            (this.loading = !0),
                            e(t)
                                .then((t) => this.updateCart())
                                .catch((t) => console.error(t));
                    });
                });
            },
            _increaseHandler() {
                this._eventHandler(this.increaseButton, (t) => u({ line: t.dataset.cartIncreaseItem, quantity: this._getQuantity(t) + 1 }));
            },
            _decreaseHandler() {
                this._eventHandler(this.decreaseButton, (t) => u({ line: t.dataset.cartDecreaseItem, quantity: this._getQuantity(t) - 1 }));
            },
            _removeHandler() {
                this._eventHandler(this.removeButton, (t) => u({ line: t.dataset.cartRemoveItem, quantity: 0 }));
            },
           _update_ck() {
                this._eventHandler_ck(this.update_input, (t) => u({ line: t.dataset.cartUpdateItem, quantity:  this._getQuantity(t) }));
            },
        }),
        r(["cart"]);
})();
